import { h, ComponentType, Ref } from "preact";

import classname from "../../../../foundation/utils/classname";

import IconArrowRight from "../../Icons/IconArrowRight";
import IconProps from "../../Icons/IconProps";

import styles from "./RightPanelFooterCell.module.css";

type Props = {
    icon: ComponentType<IconProps>;
    title: string;
    description: string;
    baseRef?: Ref<HTMLDivElement>;
    onClick: () => void;
};

function RightPanelFooterCell({
    icon: Icon,
    title,
    description,
    baseRef,
    onClick
}: Props) {
    return (
        <div ref={baseRef} class={classname(styles.rightPanelFooterCell)} onClick={onClick}>
            <div class={classname(styles.topLine)}>
                <Icon class={styles.icon}/>
                <span class={classname(styles.title, "caption-1", "medium", "ellipsis")}>
                    {title}
                </span>
                <IconArrowRight/>
            </div>
            <div class={classname(styles.bottomLine, "caption-2")}>
                {description}
            </div>
        </div>
    );
}

export default RightPanelFooterCell;
export { Props as RightPanelFooterCellProps };
